export class DataProvider {
    constructor(items) {
        this.items = items;
    }
}
